import { Observable } from 'rxjs';
import {
  Component,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { PurposeDto } from '@cradua/data';

@Component({
  selector: 'cradua-purpose',
  templateUrl: './purpose.component.html',
  styleUrls: ['./purpose.component.scss'],
})
export class PurposeComponent implements OnChanges {
  purposeForm: FormGroup;
  purposeFormArray: FormGroup;
  control = new FormControl();
  @Input() purposes: PurposeDto[];
  @Input() routeAnimationsElements: any;
  @Output() purpose = new EventEmitter<PurposeDto[]>();
  @Output() deletePurposeEvent = new EventEmitter<any>();

  selectedPurpose: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createPurposeForm();
  }

  createPurposeForm() {
    this.purposeForm = this.fb.group({
      PurposeName: ['', Validators.required],
      id: null,
    });
    this.purposeFormArray = this.fb.group({ Purposes: this.fb.array([]) });
    this.setPurpose();
  }

  // method to display purposes
  setPurpose() {
    const control = this.purposeFormArray.controls.Purposes as FormArray;
    this.purposes.forEach((e) => {
      control.push(
        this.fb.group({
          PurposeName: e.PurposeName,
          id: e.id,
        })
      );
    });
  }

  // method to add Purpose
  addPurpose(value: PurposeDto) {
    const control = this.purposeFormArray.controls.Purposes as FormArray;
    control.insert(
      0,
      this.fb.group({
        PurposeName: value.PurposeName,
        id: null,
      })
    );
  }

  selectPurpose(value) {}

  // method to delete purpose from arrary list
  deletePurpose(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.purposeFormArray.controls.Purposes as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.purposes.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.purposes[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: PurposeDto) {
    if (this.purposeForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.purposeFormArray
        .get('Purposes')
        ['controls'][this.selectedIndex].patchValue({
          PurposeName: formValue.PurposeName,
        });
    } else {
      this.addPurpose(formValue);
    }
    this.selectedIndex = null;
    this.purposeForm.reset();
  }

  onEdit(index, value: PurposeDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.purposeForm.patchValue({ PurposeName: value.PurposeName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.purposeForm.reset();
  }

  onSubmit(formValue: PurposeDto[]) {
    this.purpose.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deletePurposeEvent.emit(this.filteredDelete);
    }
  }
}
